import React from 'react'
import ProTeacherDashbaord from '../../features/proteacher/ProTeacherDashbaord'

const ProTeacherDashbaordPage = () => {
  return (
   <ProTeacherDashbaord/>
  )
}

export default ProTeacherDashbaordPage
